<template>
  <div class="w-full">
    <label class="label" :for="label">
      {{ label }}
    </label>
    <div class="relative">
      <input v-model="fieldModel" v-validate="validationRule" :data-vv-name="field" :name="field" class="hidden">
      <datepicker :input-class="{'field': true, 'border-grey-lighter': !errors.has(field),'border-red': errors.has(field) }" v-model="fieldModel" :open-date="openDate" :disabled="disabledDates" @input="handleInput"></datepicker>
      <div class="pointer-events-none absolute pin-y pin-r flex items-center px-2 text-navy">
        <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
          <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
        </svg>
      </div>
    </div>
    <p class="text-red text-xs italic mt-3" v-show="errors.has(field)">{{ validationMessage }}</p>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';
export default {
  name: 'FieldDate',
  inject: ['$validator'],
  data() {
    return {
      fieldDirty: false,
    };
  },
  components: {
    Datepicker,
  },
  props: {
    namespace: {
      type: String,
    },
    field: {
      type: String,
    },
    label: {
      type: String,
    },
    placeholder: {
      type: String,
      default: '',
    },
    validationRule: {
      default: '',
    },
    validationMessage: {
      type: String,
      default: '',
    },
    minDate: {
      default: false,
    },
  },
  computed: {
    openDate() {
      if (this.minDate) {
        return moment()
          .subtract(this.minDate, 'year')
          .toDate();
      }
      return new Date();
    },
    disabledDates() {
      const disabledState = {};

      if (this.minDate) {
        disabledState.from = moment()
          .subtract(this.minDate, 'year')
          .toDate();
      }

      return disabledState;
    },
    fieldModel: {
      get() {
        const data =
          this.$store.state[this.namespace][this.field] === ''
            ? ''
            : new Date(this.$store.state[this.namespace][this.field]);

        if (this.fieldDirty) {
          this.$validator.validate(this.field, data);
        }

        return data;
      },
      set(value) {
        this.$store.commit(`${this.namespace}/setField`, {
          field: this.field,
          value,
        });
      },
    },
  },
  methods: {
    handleInput() {
      this.fieldDirty = true;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/FieldDate.vue